import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import conf from "../../../config.js";

export default class IndexPenjadwalanCerdas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            institusi_id: "",
            tahun_ajaran: "",
            semester: "",
            total_rombel: 0,
            total_guru: 0,
            total_penugasan: 0,
            total_waktu: 0,
            versi_aktif: null,
            semua_versi: [],
            loading: true,
            rename_id: null,
            rename_value: "",
        };
    }

    componentDidMount() {
        this.getSession();
    }

    getSession() {
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios
            .post(
                `${conf.uri_backend}api/v1/auth/sso/user`,
                { token: localStorage.getItem("token") },
                { headers: { Authorization: tokenApi } }
            )
            .then((res) => {
                const now = new Date();
                const month = now.getMonth() + 1;
                const year = now.getFullYear();
                let tahun_ajaran, semester;
                if (month >= 7) {
                    tahun_ajaran = `${year} / ${year + 1}`;
                    semester = "1";
                } else {
                    tahun_ajaran = `${year - 1} / ${year}`;
                    semester = "2";
                }
                const npsn = res.data.access_to;
                axios.get(`${conf.uri_backend}api/v1/select-institusi/${npsn}`, { headers: { Authorization: tokenApi } })
                    .then((instRes) => {
                        this.setState(
                            {
                                institusi_id: instRes.data.id,
                                tahun_ajaran: tahun_ajaran,
                                semester: semester,
                            },
                            () => this.getDashboard()
                        );
                    })
                    .catch(() => {
                        this.setState(
                            {
                                institusi_id: npsn,
                                tahun_ajaran: tahun_ajaran,
                                semester: semester,
                            },
                            () => this.getDashboard()
                        );
                    });
            });
    }

    getTahunAjaranOptions() {
        const now = new Date();
        const year = now.getFullYear();
        const options = [];
        for (let y = year + 1; y >= year - 3; y--) {
            options.push(`${y} / ${y + 1}`);
        }
        return options;
    }

    onFilterChange(partial) {
        this.setState({ ...partial, loading: true, versi_aktif: null, semua_versi: [] }, () => this.getDashboard());
    }

    getDashboard() {
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios
            .get(
                `${conf.uri_backend}api/v1/jadwal-v2/dashboard?institusi=${this.state.institusi_id}&tahun_ajaran=${this.state.tahun_ajaran}&semester=${this.state.semester}`,
                { headers: { Authorization: tokenApi } }
            )
            .then((res) => {
                if (res.data.status) {
                    const d = res.data.data;
                    this.setState({
                        total_rombel: d.total_rombel,
                        total_guru: d.total_guru,
                        total_penugasan: d.total_penugasan,
                        total_waktu: d.total_waktu,
                        versi_aktif: d.versi_aktif,
                        semua_versi: d.semua_versi || [],
                        loading: false,
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => this.setState({ loading: false }));
    }

    activateVersi(id) {
        if (!window.confirm("Aktifkan versi jadwal ini?")) return;
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios
            .post(
                `${conf.uri_backend}api/v1/jadwal-v2/versi/activate/${id}`,
                {},
                { headers: { Authorization: tokenApi } }
            )
            .then(() => this.getDashboard());
    }

    deleteVersi(id) {
        if (!window.confirm("Hapus versi jadwal ini? Data jadwal akan ikut terhapus.")) return;
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios
            .delete(`${conf.uri_backend}api/v1/jadwal-v2/versi/${id}`, {
                headers: { Authorization: tokenApi },
            })
            .then(() => this.getDashboard());
    }

    renameVersi(id) {
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios
            .post(
                `${conf.uri_backend}api/v1/jadwal-v2/versi/rename/${id}`,
                { nama_versi: this.state.rename_value },
                { headers: { Authorization: tokenApi } }
            )
            .then(() => {
                this.setState({ rename_id: null, rename_value: "" });
                this.getDashboard();
            });
    }

    render() {
        const { total_rombel, total_guru, total_penugasan, total_waktu, versi_aktif, semua_versi, loading, tahun_ajaran, semester } = this.state;

        return (
            <div className="pc-container">
                {/* Header */}
                <div className="pc-header">
                    <div className="pc-header-content">
                        <div className="pc-header-text">
                            <h1 className="pc-header-title">
                                <i className="bx bx-calendar-star"></i> Penjadwalan Cerdas
                            </h1>
                            <p className="pc-header-subtitle">
                                Sistem penjadwalan otomatis dengan deteksi bentrokan dan manajemen versi
                            </p>
                        </div>
                        <div className="pc-header-actions">
                            <Link to="/penjadwalan-cerdas/wizard" className="pc-btn pc-btn-primary">
                                <i className="bx bx-plus-circle"></i> Buat Jadwal Baru
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Filter */}
                <div className="pc-filters-guide">
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">1</div>
                        <div className="pc-filter-item">
                            <label>Tahun Ajaran</label>
                            <select className="pc-input" value={tahun_ajaran}
                                onChange={(e) => this.onFilterChange({ tahun_ajaran: e.target.value })}>
                                {this.getTahunAjaranOptions().map((ta) => <option key={ta} value={ta}>{ta}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">2</div>
                        <div className="pc-filter-item">
                            <label>Semester</label>
                            <select className="pc-input" value={semester}
                                onChange={(e) => this.onFilterChange({ semester: e.target.value })}>
                                <option value="1">Ganjil</option>
                                <option value="2">Genap</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* Stats Cards */}
                <div className="pc-stats-grid">
                    <div className="pc-stat-card pc-stat-indigo">
                        <div className="pc-stat-icon"><i className="bx bx-group"></i></div>
                        <div className="pc-stat-info">
                            <span className="pc-stat-value">{loading ? "..." : total_rombel}</span>
                            <span className="pc-stat-label">Total Rombel</span>
                        </div>
                    </div>
                    <div className="pc-stat-card pc-stat-emerald">
                        <div className="pc-stat-icon"><i className="bx bx-user"></i></div>
                        <div className="pc-stat-info">
                            <span className="pc-stat-value">{loading ? "..." : total_guru}</span>
                            <span className="pc-stat-label">Total Guru</span>
                        </div>
                    </div>
                    <div className="pc-stat-card pc-stat-amber">
                        <div className="pc-stat-icon"><i className="bx bx-book-open"></i></div>
                        <div className="pc-stat-info">
                            <span className="pc-stat-value">{loading ? "..." : total_penugasan}</span>
                            <span className="pc-stat-label">Penugasan Mapel</span>
                        </div>
                    </div>
                    <div className="pc-stat-card pc-stat-rose">
                        <div className="pc-stat-icon"><i className="bx bx-time-five"></i></div>
                        <div className="pc-stat-info">
                            <span className="pc-stat-value">{loading ? "..." : total_waktu}</span>
                            <span className="pc-stat-label">Slot Waktu</span>
                        </div>
                    </div>
                </div>

                {/* Quick Actions */}
                <div className="pc-section">
                    <h2 className="pc-section-title">Aksi Cepat</h2>
                    <div className="pc-quick-actions">
                        <Link to="/penjadwalan-cerdas/wizard" className="pc-action-card">
                            <i className="bx bx-magic-wand"></i>
                            <span>Wizard Jadwal</span>
                            <small>Buat jadwal langkah demi langkah</small>
                        </Link>
                        <Link to="/penjadwalan-cerdas/semua-kelas" className="pc-action-card">
                            <i className="bx bx-table"></i>
                            <span>Jadwal Semua Kelas</span>
                            <small>Lihat jadwal seluruh rombel</small>
                        </Link>
                        <Link to="/penjadwalan-cerdas/jadwal-kelas" className="pc-action-card">
                            <i className="bx bx-grid-alt"></i>
                            <span>Jadwal Per Kelas</span>
                            <small>Lihat jadwal setiap rombel</small>
                        </Link>
                        <Link to="/penjadwalan-cerdas/semua-guru" className="pc-action-card">
                            <i className="bx bx-group"></i>
                            <span>Jadwal Semua Guru</span>
                            <small>Lihat jadwal seluruh guru</small>
                        </Link>
                        <Link to="/penjadwalan-cerdas/jadwal-guru" className="pc-action-card">
                            <i className="bx bx-id-card"></i>
                            <span>Jadwal Per Guru</span>
                            <small>Lihat jadwal setiap guru</small>
                        </Link>
                        <Link to="/penjadwalan-cerdas/edit-jadwal" className="pc-action-card">
                            <i className="bx bx-edit-alt"></i>
                            <span>Edit Jadwal</span>
                            <small>Edit slot, tukar posisi & perbaiki bentrok</small>
                        </Link>
                        <Link to="/penjadwalan-cerdas/rekap" className="pc-action-card">
                            <i className="bx bx-bar-chart-alt-2"></i>
                            <span>Rekap & Statistik</span>
                            <small>Analisis jam mengajar guru</small>
                        </Link>
                    </div>
                </div>

                {/* Active Version */}
                {versi_aktif && (
                    <div className="pc-section">
                        <h2 className="pc-section-title">
                            <i className="bx bx-check-circle" style={{ color: "#10b981" }}></i> Versi Aktif
                        </h2>
                        <div className="pc-version-active">
                            <div className="pc-version-info">
                                <strong>{versi_aktif.nama_versi}</strong>
                                <span className="pc-version-date">
                                    {new Date(versi_aktif.created_at).toLocaleDateString("id-ID", {
                                        weekday: "long",
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </span>
                            </div>
                            <div className="pc-version-actions">
                                <Link to="/penjadwalan-cerdas/jadwal-kelas" className="pc-btn pc-btn-sm pc-btn-outline">
                                    <i className="bx bx-show"></i> Lihat Jadwal
                                </Link>
                            </div>
                        </div>
                    </div>
                )}

                {/* All Versions */}
                <div className="pc-section">
                    <h2 className="pc-section-title">
                        <i className="bx bx-history"></i> Riwayat Versi Jadwal
                    </h2>
                    {semua_versi.length === 0 ? (
                        <div className="pc-empty-state">
                            <i className="bx bx-calendar-x"></i>
                            <p>Belum ada jadwal yang digenerate</p>
                            <Link to="/penjadwalan-cerdas/wizard" className="pc-btn pc-btn-primary">
                                Buat Jadwal Pertama
                            </Link>
                        </div>
                    ) : (
                        <div className="pc-version-list">
                            {semua_versi.map((v) => (
                                <div key={v.id} className={`pc-version-item ${v.is_aktif ? "pc-version-active-item" : ""}`}>
                                    <div className="pc-version-left">
                                        {v.is_aktif && <span className="pc-badge pc-badge-success">Aktif</span>}
                                        {this.state.rename_id === v.id ? (
                                            <div className="pc-inline-edit">
                                                <input
                                                    type="text"
                                                    value={this.state.rename_value}
                                                    onChange={(e) => this.setState({ rename_value: e.target.value })}
                                                    className="pc-input-sm"
                                                    autoFocus
                                                />
                                                <button onClick={() => this.renameVersi(v.id)} className="pc-btn pc-btn-xs pc-btn-primary">
                                                    <i className="bx bx-check"></i>
                                                </button>
                                                <button
                                                    onClick={() => this.setState({ rename_id: null })}
                                                    className="pc-btn pc-btn-xs pc-btn-outline"
                                                >
                                                    <i className="bx bx-x"></i>
                                                </button>
                                            </div>
                                        ) : (
                                            <strong>{v.nama_versi}</strong>
                                        )}
                                        <span className="pc-version-meta">
                                            {v.jadwal_count || 0} entri •{" "}
                                            {new Date(v.created_at).toLocaleDateString("id-ID", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                        </span>
                                    </div>
                                    <div className="pc-version-right">
                                        <button
                                            onClick={() => this.setState({ rename_id: v.id, rename_value: v.nama_versi })}
                                            className="pc-btn pc-btn-xs pc-btn-ghost"
                                            title="Rename"
                                        >
                                            <i className="bx bx-edit"></i>
                                        </button>
                                        {!v.is_aktif && (
                                            <>
                                                <button
                                                    onClick={() => this.activateVersi(v.id)}
                                                    className="pc-btn pc-btn-xs pc-btn-success"
                                                    title="Aktifkan"
                                                >
                                                    <i className="bx bx-check-circle"></i>
                                                </button>
                                                <button
                                                    onClick={() => this.deleteVersi(v.id)}
                                                    className="pc-btn pc-btn-xs pc-btn-danger"
                                                    title="Hapus"
                                                >
                                                    <i className="bx bx-trash"></i>
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
